import axios from 'axios';
import useSWRImmutable from 'swr/immutable';

import { Content } from '../pages/api/content';

const fetcher = async (url: string) => axios.get(url).then((res) => res.data);

export const getContent = (type: string, id: string, commentsOnly: boolean) => {
    const {
        data: content,
        error,
        isLoading,
    } = useSWRImmutable<Content>(
        `/api/community/content/${type}/${id}/${
            commentsOnly ? 'comments' : ''
        }`,
        fetcher,
        {
            onErrorRetry: (
                errorMessage,
                key,
                config,
                revalidate,
                { retryCount }
            ) => {
                if (errorMessage.status === 404) return;
                if (retryCount >= 4) return;
                setTimeout(() => revalidate({ retryCount }), 5000);
            },
        }
    );

    return {
        content,
        isLoading,
        isError: error,
        type: undefined,
        parentType: '',
        parentHash: '',
        hash: undefined,
    };
};

export const getComments = (type: string, id: string) => {
    const {
        data: comments,
        error: commentError,
        isLoading: commentsLoading,
    } = useSWRImmutable<Content>(
        `/api/community/content/${type}/${id}/comments`,
        fetcher,
        {
            onErrorRetry: (
                errorMessage,
                key,
                config,
                revalidate,
                { retryCount }
            ) => {
                if (errorMessage.status === 404) return;
                if (retryCount >= 4) return;
                setTimeout(() => revalidate({ retryCount }), 5000);
            },
        }
    );
    return {
        comments,
        isLoading: commentsLoading,
        isError: commentError,
    };
};

export default getContent;
